import { render } from "./changePassword.vue?vue&type=template&id=4c5e1e5e&scoped=true"
import script from "./changePassword.vue?vue&type=script&lang=js"
export * from "./changePassword.vue?vue&type=script&lang=js"

import "./changePassword.vue?vue&type=style&index=0&id=4c5e1e5e&lang=scss"
import "./changePassword.vue?vue&type=style&index=1&id=4c5e1e5e&lang=scss&scoped=true"

import exportComponent from "/Users/bruno/Documents/projects/pixeon-c/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c5e1e5e"]])

export default __exports__